const LoadingPositionFixed = { 
    "abyss-loading-overlay-dialog": { position: "fixed!important", zIndex:"2001!important"  },         
    "abyss-loading-overlay-overlay": { position: "fixed", zIndex:"2000!important" } 
}

export { LoadingPositionFixed }